import { render } from "./orderPage.vue?vue&type=template&id=0a49ae4b"
import script from "./orderPage.vue?vue&type=script&lang=js"
export * from "./orderPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__